exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-close {\n  background-color: transparent;\n  border: 0;\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.5;\n}\n.border-encoded {\n  border: 2px solid #cad0d7;\n  border-radius: 5px;\n}\n", ""]);

// exports
